export const ACCESS_TOKEN = 'access_token';
export const MONTHS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export type WeekStringType =
  | 'mon'
  | 'tue'
  | 'wed'
  | 'thu'
  | 'fri'
  | 'sat'
  | 'sun';
export const START_WEEK: WeekStringType = 'sun';
export const DAYS = [0, 1, 2, 3, 4, 5, 6] as const;
export const CLOSED_AUTOLIQUIDATE_STATUS = 'closed (autoliquidate)';

export const dateFormatPayload = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';

export const USER_DUPLICATE_EMAIL_OR_NICKNAME =
  'USER__DUPLICATE_EMAIL_OR_NICKNAME';
export const SUPPORT_EMAIL = 'support@leelootrading.com';
export const USER_NOT_FOUND = 'User not found';
